import { useCallback, useMemo, useState } from 'react';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { FornecedorDropDown } from '../domain/models/fornecedor_dropdown';
import { DefaultAutocomplete } from './default_autocomplete';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined;
  onChange: (newValue: string | number | undefined) => void;
  error?: boolean;
  helperText?: string | null;
};

export const DefaultFornecedor = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,
}: Props) => {

  const { pushErrorNotification } = usePageLoader();
  const [fornecedorDropDown, setFornecedorDropDown] = useState<FornecedorDropDown[]>([]);

  const {
    commons: {
      getFornecedorDropDownUseCase,
    },
  } = useDependencyInjection();

  const selectedFornecedor = useMemo(() => {
    return fornecedorDropDown.find(x => String(x.idFornecedor) === String(value)) ?? null;
  }, [
    value,
    fornecedorDropDown,
  ]);

  const loadFornecedorDropDown = useCallback(async () => {
    try {
      const result = await getFornecedorDropDownUseCase.getFornecedorDropDown();
      setFornecedorDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar Fornecedor!'));
    }
  }, [getFornecedorDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadFornecedorDropDown();
  });


  return (
    <>
      <DefaultAutocomplete
        label={label}
        getOptionKey={x => x.idFornecedor}
        getOptionLabel={x => x.nomeFantasia}
        options={fornecedorDropDown}
        value={selectedFornecedor}
        onChange={e => onChange(e ? e.idFornecedor : undefined)}
      />

      {/*
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={fornecedorDropDown}
        getOptionLabel={(opt) => String(opt.nomeFantasia)}
        isOptionEqualToValue={(opt, val) => String(opt.nomeFantasia) === String(val.nomeFantasia)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={fornecedorDropDown.find(x => String(x.idFornecedor) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.idFornecedor : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
      */}
    </>
  );
};